const domain = {
	prod: "https://api.expressreadertw.com",
	uat: "https://uatapi.expreader.com",
};

const lcids = [
	{ title: "台灣", key: "1028" },
	{ title: "香港", key: "3076" },
	{ title: "中國", key: "2052" },
];

const API = {
	version: "v1",
	magz: {
		brand: {
			page: "/api/v1/magz/brand",
			oldmags: (brandcode) => `/api/v1/magz/brands/${brandcode}`,
			issue: (issueId) => `/api/v1/magz/issue/${issueId}`,
			chapter: (nmid) => `/api/v1/magz/chapter/${nmid}`,
		},
		search: "/api/v2/express/search",
	},
	Code: {
		ok: "OK",
	},
};

export { domain, API, lcids };
